import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['inhaler/checkPermission']) {
      await store.dispatch('inhaler/fetchAudioStream')
  }
  next()
}
